import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { URLS } from '@shared-config/urls';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private httpClient = inject(HttpClient);

  getSubscriptionData(): Observable<any> {
    return this.httpClient.get<any>(`${URLS.SUBSCRIPTION}`);
  }
}
